/** Calendar days use local time, not UTC, for Date values. */
export function tournamentDay(value?: string | Date | null): string | undefined {
  if (!value) return undefined;
  if (typeof value === 'string') return /^\d{4}-\d{2}-\d{2}/.test(value) ? value.slice(0, 10) : undefined;
  if (Number.isNaN(value.getTime())) return undefined;
  return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
}

/** Open today, clamped to the inclusive tournament dates, including days without matches. */
export function defaultTournamentDay(start?: string | Date | null, end?: string | Date | null, now = new Date()): string {
  const today = tournamentDay(now)!;
  const first = tournamentDay(start);
  const last = tournamentDay(end) ?? first;
  if (first && today < first) return first;
  if (last && today > last) return last;
  return today;
}

/** OpenAPI date-only values are decoded as UTC Dates; restore their calendar day locally. */
export function fromApiTournamentDate(value?: string | Date | null): Date | undefined {
  if (!value) return undefined;
  const day = value instanceof Date ? value.toISOString().slice(0, 10) : tournamentDay(value);
  if (!day) return undefined;
  const [year, month, date] = day.split('-').map(Number);
  return new Date(year, month - 1, date);
}

/** Match instants use the viewer's timezone; scheduled days take precedence over setup dates. */
export function defaultTournamentScheduleDay(
  matchTimes: readonly (string | Date | null | undefined)[],
  start?: string | Date | null,
  end?: string | Date | null,
  now = new Date(),
): string {
  const days = matchTimes.flatMap(value => {
    if (!value) return [];
    const day = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)
      ? tournamentDay(value) : tournamentDay(value instanceof Date ? value : new Date(value));
    return day ? [day] : [];
  }).sort();
  return days.length
    ? defaultTournamentDay(days[0], days[days.length - 1], now)
    : defaultTournamentDay(start, end, now);
}
